import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteGovReportingFacilityMutationAtom = createMutationAtomFactory(
  'settings.govReportingFacilityDelete',
  ({ id }: { id: string }) => ({
    complianceGovernmentReportingFacilityDelete: {
      __args: {
        id,
      },
    },
  }),
);
